import React from "react";
import PropTypes from "prop-types";

/**
 * Shared refresh / reload vector for Update Now, Generate Now, and eligibility check.
 * Stroke uses currentColor so parents can tint it.
 */
export function LeadRefreshIcon({ spinning = false, className = "" }) {
    const classes = [
        "lead-summary-refresh-icon",
        spinning ? "is-spinning" : "",
        className
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <span className={classes} aria-hidden="true">
            <svg
                className="lead-summary-refresh-icon__vector"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.25 7C12.25 8.03835 11.9421 9.05339 11.3652 9.91674C10.7883 10.7801 9.9684 11.453 9.00909 11.8504C8.04978 12.2477 6.99418 12.3517 5.97578 12.1491C4.95738 11.9466 4.02192 11.4465 3.28769 10.7123C2.55347 9.97809 2.05345 9.04262 1.85088 8.02422C1.64831 7.00582 1.75227 5.95022 2.14963 4.99091C2.54699 4.0316 3.2199 3.21166 4.08326 2.63478C4.94662 2.05791 5.96165 1.75 7 1.75C8.47 1.75 9.87584 2.33333 10.9317 3.34833L12.25 4.66667M9.33333 4.66667H12.25L12.25 1.75"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
}

LeadRefreshIcon.propTypes = {
    spinning: PropTypes.bool,
    className: PropTypes.string
};
